import React, {useCallback} from "react"
import css from "../AuthPage/AuthPage.module.scss"
import {ChangeLanguage} from "../../features/ChangeLanguage/ChangeLanguage"
import {Box} from "scholastic-client-components/src/ui/Box/Box"
import {SSOErrorTemplate} from "../../features/SSO/SSOErrorTemplate/SSOErrorTemplate"
import {useChangeLanguageAPI} from "../../features/ChangeLanguage/useChangeLanguageAPI"
import {useSelector} from "react-redux"
import {changeLanguageSelectors} from "../../slices/changeLanguageSlice"
import {useTranslation} from "react-i18next"
import {useHistory} from "react-router-dom"
import {TSNWebsiteLink} from "../../features/TSNWebsiteLink/TSNWebsiteLink"
import {SSOState} from "../../features/SSO/types"
import {SSOErrorMessage} from "./SSOErrorMessage"

export const SSOStatePage: React.FC<{state: SSOState}> = ({state}) => {
    const {t} = useTranslation(["auth_portal"])
    const history = useHistory()
    useChangeLanguageAPI()

    const locales = useSelector(changeLanguageSelectors.getData)?.locales

    const handleRedirectToLogin = useCallback(() => {
        history.push("/")
    }, [history])

    if (state === SSOState.SUCCESS) return null

    return (
        <>
            <div className={css.language}>
                <ChangeLanguage locales={locales} />
            </div>

            <Box
                flex={{justifyContent: "center", alignItems: "center", columnDirection: true}}
                propsStyles={{minHeight: "80vh"}}
            >
                <SSOErrorTemplate
                    headerTitle={t`auth_portal:auth_page.sso_disabled.login_error_title`}
                    message={<SSOErrorMessage />}
                    handleRedirectToLogin={handleRedirectToLogin}
                />

                <div className={css.tsn}>
                    <TSNWebsiteLink />
                </div>
            </Box>
        </>
    )
}
